<template>

<!--border-bottom m-2 pb-1-->
    <div :class="{ 'required': dateRequired && editable }" class="d-flex flex-column">
        <span class="text-secondary form-field-label">{{ title }}</span>
        <div v-if="!clearable" class="d-flex flex-column flex-sm-row justify-content-start">
            <b-form-datepicker v-if="editable"
                               v-model="date"
                               :locale="'ru'"
                               :label-no-date-selected="'Не выбрано'"
                               :label-help="''"
                               :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                               :state="state"
                               class="text-nowrap mr-2 mb-2 mb-sm-0"
                               @input="onDateUpdated"/>
            <span v-else><b-icon icon="calendar" class="text-secondary mr-2" /> {{ date ? date : 'Не указана' }}</span>
            <b-form-timepicker v-if="showTimepicker && editable"
                               v-model="time"
                               :locale="'ru'"
                               :label-no-time-selected="'Не выбрано'"
                               :label-help="''"
                               :state="state"
                               no-close-button
                               class="text-nowrap" @input="onTimeUpdated" />
            <span v-if="showTimepicker && !editable" class="ml-3"><b-icon icon="clock" class="text-secondary" /> {{ time }}</span>
        </div>
        <div v-else class="d-flex flex-column flex-sm-row justify-content-start">
            <b-form-datepicker v-if="editable"
                               v-model="date"
                               :locale="'ru'"
                               :label-no-date-selected="'Не выбрано'"
                               :label-help="''"
                               :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                               :state="state"
                               class="text-nowrap mr-2 mb-2 mb-sm-0"
                               reset-button
                               label-reset-button="Очистить"
                               @input="onDateUpdated"/>
            <span v-else><b-icon icon="calendar" class="text-secondary mr-2" /> {{ date ? date : 'Не указана' }}</span>
            <b-form-timepicker v-if="showTimepicker && editable"
                               v-model="time"
                               :locale="'ru'"
                               :label-no-time-selected="'Не выбрано'"
                               :label-help="''"
                               :state="state"
                               no-close-button
                               class="text-nowrap" @input="onTimeUpdated" />
            <span v-if="showTimepicker && !editable" class="ml-3"><b-icon icon="clock" class="text-secondary" /> {{ time }}</span>
        </div>
    </div>
</template>

<script>
    import FormField from "./FormField";
    import {todayStr} from "@/utils/dateFormat";

    export default {
        name: "DateTimePicker",
        components: { FormField },
        props: {
            name: { type: String },
            title: { type: String },
            editable: { type: Boolean, default: true },
            dateRequired: { type: Boolean, default: true },
            timeRequired: { type: Boolean, default: false },
            showTimepicker: { type: Boolean, default: false },
            initialDateString: { type: String, default: null },
            state: {type: Boolean },
            clearable: { type: Boolean, default: false },
        },
        data() {
            return {
                date: null,
                time: '00:00:00',
                dateString: null
            }
        },
        methods: {
            cancelChanges() {
                if (this.initialDateString) {
                    const dateTimeComponents = this.initialDateString.split(' ');
                    this.time = dateTimeComponents[1];
                    if (this.editable) {
                        const dateComponents = dateTimeComponents[0].split('.');
                        this.date = dateComponents.reverse().join('-');
                    } else {
                        this.date = dateTimeComponents[0];
                    }
                } else {
                    // this.date = todayStr()
                    // console.log(this.date, new Date().getDate())
                }
            },
            feDate(dateStr) {
                const dateComponents = dateStr.split('.');
                return [dateComponents[2], dateComponents[1], dateComponents[0]].join('-');
            },
            beDate(dateStr) {
                const dateComponents = dateStr.split('-');
                return [dateComponents[2], dateComponents[1], dateComponents[0]].join('.');
            },
            onDateUpdated(e) {
                this.dateString = Boolean(e) ? this.beDate(e) : null;
                if (this.dateString && (this.timeRequired || this.showTimepicker)) {
                    this.dateString +=  ' ' + this.time;
                }
                this.$emit('date-changed', this.dateString, this.name);
            },
            onTimeUpdated(e) {
                this.dateString = this.beDate(this.date) + ' ' + e;
                this.$emit('date-changed', this.dateString, this.name);
            }
        },
        mounted() {
            this.cancelChanges()
        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .required {
        & .form-field-label::after {
            color: $danger;
            content: '  *';
        }
    }

    .form-control {
        &.is-valid {
            border-color: #28a745;
            padding-right: calc(1.5em + 0.75rem);
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right calc(0.375em + 0.1875rem) center;
            background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
        }

        &.is-invalid {
            border-color: #dc3545;
            padding-right: calc(1.5em + 0.75rem);
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right calc(0.375em + 0.1875rem) center;
            background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
        }
    }
</style>